import React from 'react';
import styled from 'styled-components';
import { useImagesContext } from '../../../contexts/ImagesContext';
import SoulNumber from './SoulNumber';
import AnimationWithSound from '../AnimationWithSound';

export const PLAYER_SOUL_STATE = {
  NOT_DISPLAYED: 0,
  NORMAL: 1,
  INCREASING: 2,
};

const PlayerSoul = ({ amount, state }) => {
  const { images } = useImagesContext();
  return (
    <Block $background={images['play-soul.png']}>
      {state === PLAYER_SOUL_STATE.NORMAL && (
        <SoulNumber number={amount} top="60px" fontHeight="75px" />
      )}
      {state === PLAYER_SOUL_STATE.INCREASING && (
        <AnimationWithSound
          imageUrl={images['play-player-capture.png']}
          soundFile={null}
          style={{
            overflow: 'visible',
            width: 210,
            height: 175,
            left: 4,
            bottom: 0,
          }}
        />
      )}
    </Block>
  );
};

const SoulBlackCapture = styled.img`
  position: absolute;
  left: 0;
  bottom: 0;
  overflow: visible;
`;

const Block = styled.div`
  position: absolute;
  top: 670px;
  left: 0px;
  width: 155px;
  height: 176px;
  background-image: url(${(props) => props.$background});
  background-size: cover;
  background-repeat: no-repeat;
`;
export default PlayerSoul;
